import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, X } from "lucide-react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShow(true), 2000);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") { setShow(false); setDeferredPrompt(null); }
  };

  const handleDismiss = () => {
    setShow(false);
  };

  if (!deferredPrompt) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ type: "spring", stiffness: 400, damping: 30 }}
          className="fixed top-0 left-0 right-0 z-[60] safe-area-top"
          data-testid="pwa-install-prompt"
        >
          <div className="bg-gg-surface/95 backdrop-blur-md border-b border-white/10 px-4 py-2.5 flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-gg-red/10 flex items-center justify-center shrink-0">
              <Download size={16} className="text-gg-red" />
            </div>
            <p className="text-white text-xs flex-1 min-w-0"><strong>Install GG Fitness</strong> <span className="text-zinc-400">for quick access</span></p>
            <button onClick={handleInstall}
              className="bg-gg-red hover:bg-gg-red-hover text-white text-[10px] font-heading uppercase tracking-wider px-3 py-1.5 rounded-lg shrink-0 transition-colors"
              data-testid="pwa-install-btn">
              Install
            </button>
            <button onClick={handleDismiss} className="text-zinc-500 hover:text-white shrink-0" data-testid="pwa-dismiss">
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
